import { OnBoarding } from "@components/index";
import { Button, Card, Col, Radio, Row, Space, Typography } from "antd";
import { useState } from "react";
import styles from "../Auth.module.scss";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

export const Centralized = () => {
  const [selected, setSelected] = useState("");
  const navigate = useNavigate();
  return (
    <OnBoarding>
      <Row>
        <Col span={18}>
          <Title level={2}>Welcome to </Title>
          <Col
            className={styles.textCenter}
            span={27}
            style={{ padding: `${styles.whitespace2} 0px`, color: styles.gray }}
          ></Col>
          <Col span={27}>
            <Card
              onClick={() => setSelected("Centralized")}
              className={selected === "Centralized" ? styles.displayFlexCenter : ""}
              style={{ marginBottom: styles.whitespace3, position: "relative" }}
            >
              <Radio
                checked={selected === "Centralized"}
                style={{ position: "absolute", top: "10px", right: "10px" }}
              />
              <div></div>
              <Title level={4}>Centralized CMS</Title>
              <Typography.Text>
                In sed gravida lorem nunc. Dignissim nam dolor magnis vitae. Senectus duis a eu nullam nam eu.
              </Typography.Text>
            </Card>
          </Col>
          <Col
            style={{ marginTop: styles.whitespace5 }}
            span={27}
          >
            <Button
              size="large"
              type="ghost"
              block
            >
              <Space
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button onClick={() => {
                navigate(`/centralized/centralizedBanner`, { replace: true })
                }}>Continue</Button>
              </Space>
            </Button>
          </Col>
        </Col>
      </Row>
    </OnBoarding>
  );
};
